module.exports = __webpack_public_path__ + "static/media/northernlights.d0c1e2e3.gif";